export default "/assets/images/unit-slide2.df88c47d767f4ed4.webp";